import $store from "@/store";

let configPage = {
	defaultUi: {
		title: process.env.VUE_APP_TITLE,
		ico: 'https://vybbasevr.vyb.cn/342b2fac_fa6c_4c01_99fa_1512127da7f71642821309973',
		logo: 'https://vybbasevr.vyb.cn/4a8578bb_5977_42f2_a285_81294f61a4cc1642821361882',
		banner: 'https://vybbasevr.vyb.cn/15b27ef5_0df7_4765_bbf8_87bab5179ca61642821378087',
		mLogo: 'https://vybbasevr.vyb.cn/fa8a4089_e130_4016_a4e4_a5e359d2f57a1642825049346',
		mBg: 'https://vybbasevr.vyb.cn/a9ef7db5_199f_4a38_9f82_54ed2a2cba3a1643193465788',
		category: 'https://vybbasevr.vyb.cn/f58d54ab_1f91_4d71_813d_3133d37af8cf1643341177361',
		company: '江苏微影邦影视科技有限公司',
		isArea: false,
		desc: '',
		logoHeight:40,//PC首页logo高度
		mLogoScale:1,
		isBgOnly:false,
		isContact: false,
		isTouchOpen: false,
		contactName: '',
		contactTel: '',
		contactCompany: '',
		contactAddress: '',
		mInitZoom: '',
		zoom:10,
		zoomMobile:10,
		zoomRange:[{min:3,max:18,scaleIcon:1,scaleText:1}]
	},
	
	category:{name:'全部',bgColor:'#55887C',txtColor:'#D5B976',icon:'https://vybbasevr.vyb.cn/48002cdd_9ba8_42d8_8c9f_8b8bdcc043361644299441802'},
	
	async getUi(subjectId) {
		let {websiteInfo} = $store.state.user;
		if (websiteInfo) {
			return websiteInfo
		}
		
		return await $store.dispatch('user/getWebsiteInfo', {subjectId, defaultUi: configPage.defaultUi});
	}
}

export default configPage
